import { render } from "./TabContainer.vue?vue&type=template&id=af3bf0a8&scoped=true"
const script = {}

import "./TabContainer.vue?vue&type=style&index=0&id=af3bf0a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3bf0a8"]])

export default __exports__